import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {RootState} from '../redux/store';
import {Nav} from '../components/nav';

interface IProps {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>;
}
const LoggedOutRoute = ({component: Component, ...otherProps}: IProps) => {
  const navigate = useNavigate();
  const {loggedIn} = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (navigate && loggedIn) {
      navigate('/home');
    }
  }, [loggedIn, navigate]);

  return (
    <>
      <Nav />
      <Component {...otherProps} />
    </>
  );
};

export default LoggedOutRoute;
